module.exports = __webpack_public_path__ + "media/images/team/lorenzo-5b206d591258a2182d2159a607954d01.jpg";